import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

const DEFAULT_FAQS = [
    { q: "What is included?", a: "One 30ml serum bottle per unit." },
    { q: "Is this safe?", a: "Yes — PCSIR certified and dermatologist approved." },
    { q: "How fast is delivery?", a: "2–3 business days to all major Pakistani cities." },
    { q: "Can I return?", a: "COD lets you inspect the parcel at delivery." },
];

export default function FaqSection({ product }) {
    const [open, setOpen] = useState(0);
    const faqs = product?.faqs?.length ? product.faqs : DEFAULT_FAQS;

    return (
        <section
            data-testid="faq-section"
            id="faqs"
            className="py-16 sm:py-20 bg-white"
        >
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 space-y-14">
                <div className="bg-forest-50 rounded-3xl p-8 border border-forest-100 text-center space-y-3">
                    <span className="text-[11px] font-bold uppercase tracking-[0.25em] text-gold-600 block">
                        About Resham Drops
                    </span>
                    <h2 className="font-serif text-3xl sm:text-4xl font-bold text-forest-800 leading-tight">
                        Your trusted partner in natural hair care.
                    </h2>
                    <p className="text-forest-900/70 text-sm sm:text-base leading-relaxed max-w-2xl mx-auto">
                        At <strong>Resham Drops</strong>, we believe healthy
                        hair is daily confidence. Every product is formulated
                        for Pakistani hair types and environmental stressors —
                        delivering clinically-backed botanical ingredients
                        straight to the scalp.
                    </p>
                </div>

                <div>
                    <div className="text-center mb-8">
                        <span className="text-gold-600 font-bold text-xs uppercase tracking-[0.25em] block mb-2">
                            Clear Answers
                        </span>
                        <h2 className="font-serif text-3xl sm:text-4xl font-bold text-forest-800">
                            Frequently Asked Questions
                        </h2>
                    </div>

                    <div className="space-y-3">
                        {faqs.map((f, i) => {
                            const active = open === i;
                            return (
                                <div
                                    key={i}
                                    data-testid={`faq-${i}`}
                                    className="border border-forest-100 rounded-2xl overflow-hidden bg-cream"
                                >
                                    <button
                                        onClick={() =>
                                            setOpen(active ? -1 : i)
                                        }
                                        className="w-full text-left p-5 font-bold text-forest-800 text-sm sm:text-base flex justify-between items-center hover:bg-forest-50/60 transition-colors"
                                    >
                                        <span>
                                            {i + 1}. {f.q}
                                        </span>
                                        <ChevronDown
                                            className={`w-5 h-5 text-forest-700 transition-transform shrink-0 ml-2 ${
                                                active ? "rotate-180" : ""
                                            }`}
                                        />
                                    </button>
                                    {active && (
                                        <div className="p-5 text-xs sm:text-sm text-forest-900/80 border-t border-forest-100 bg-white leading-relaxed">
                                            {f.a}
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </section>
    );
}
